import Logo from "@/components/7fcc/Logo";
import { FOOTER, BRAND } from "@/data/content";

export default function Footer() {
  return (
    <footer className="border-t border-line bg-ink-950 px-6 py-14" data-testid="footer">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-8 text-center">
        <Logo className="w-44 opacity-90" />
        <p className="font-display text-sm uppercase tracking-[0.28em] text-silver" data-testid="footer-brand">
          {BRAND.name}
        </p>
        <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" aria-label="Legal">
          {FOOTER.links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-xs uppercase tracking-[0.2em] text-fg-dim transition-colors duration-300 hover:text-fg"
            >
              {link.label}
            </a>
          ))}
        </nav>
        <p className="text-xs text-fg-dim" data-testid="footer-copyright">
          {FOOTER.copyright}
        </p>
      </div>
    </footer>
  );
}
